import React from 'react';
import { Dialog } from 'primereact/dialog';
import { ModalHeader } from 'shared/ModalHeader';

const AutomationRuleConflictMessage = (props) => {
  const { ruleValidationErrorData = [], onHide = () => {} } = props || {};
  return (
    <Dialog
      className="new-task-popup error-log-fix-popup"
      header={ModalHeader}
      visible
      style={{ width: '40vw' }}
      footer={<></>}
      onHide={onHide}
    >
      <div>
        <h2 className="modal-heading F-size16 text-bold mb-3">Automation Rule Conflict</h2>
        <div>
          <p>This workflow conflicts with one or more existing rules.</p>
          <p>
            The automation rules (existing & current) identified by the following triggers are conflicting with each other.
            {
              <ul>
                {ruleValidationErrorData?.map((item, idx) => {
                  return <li key={idx}>{item}</li>;
                })}
              </ul>
            }
          </p>
          <p>To proceed, please modify the actions so that they don't conflict with existing workflows.</p>
        </div>
      </div>
    </Dialog>
  );
};

export default AutomationRuleConflictMessage;
